import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, CardHeader, Col, Container, Row, Spinner, Button } from 'reactstrap'
import TableContainer from '../../Components/Common/TableContainerReactTable.js';
import useObtenerSmtpCredentials from '../../Components/Hooks/useObtenerSmtpCredentials.js';
import useCreateSmtpCredential from '../../Components/Hooks/useCreateSmtpCredential.js';
import useUpdateSmtpCredential from '../../Components/Hooks/useUpdateSmtpCredential.js';
import useDeleteSmtpCredential from '../../Components/Hooks/useDeleteSmtpCredential.js';
import ModalCrearSmtpCredential from '../../Components/modals/ModalCrearSmtpCredential.js';
import ModalModificarSmtpCredential from '../../Components/modals/ModalModificarSmtpCredential.js';
import ModalLeerSmtpCredential from '../../Components/modals/ModalLeerSmtpCredential.js';

const SmtpCredentials = () => {

    const [selectedSmtpCredential, setSelectedSmtpCredential] = useState(null);
    const [refresh, setRefresh] = useState(0);
    const { smtpCredentials, loading, error } = useObtenerSmtpCredentials(refresh);
    const [modalCrearOpen, setModalCrearOpen] = useState(false);
    const [modalModificarOpen, setModalModificarOpen] = useState(false);
    const [modalLeerOpen, setModalLeerOpen] = useState(false);
    const { createSmtpCredential, loading: createLoading, error: createError } = useCreateSmtpCredential();
    const { updateSmtpCredential, loading: updateLoading, error: updateError } = useUpdateSmtpCredential();
    const { deleteSmtpCredential, loading: deleteLoading, error: deleteError } = useDeleteSmtpCredential();

    useEffect(() => {
        document.title = "Credenciales SMTP | Siga ERP";
    }, []);

    const columns = useMemo(
        () => [
            {
                header: "Usuario",
                accessorKey: "usuario",
                enableColumnFilter: false,
            },
            {
                header: "Host SMTP",
                accessorKey: "smtp_host",
                enableColumnFilter: false,
            },
            {
                header: "Puerto",
                accessorKey: "port",
                enableColumnFilter: false,
            },
        ],
        []
    );

    const handleCellClick = (cellInfo) => {
        setSelectedSmtpCredential(cellInfo.rowData);
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader className="d-flex justify-content-between align-items-center">
                                    <h5 className="card-title mb-0">Credenciales SMTP</h5>
                                    <div className="d-flex align-items-center">
                                        <Button color="primary" className="me-2" onClick={() => setModalCrearOpen(true)} disabled={createLoading}>
                                            <i className="ri-add-line me-1"></i>Crear
                                        </Button>
                                        <Button color="info" className="me-2" onClick={() => { if (selectedSmtpCredential) setModalLeerOpen(true); }} disabled={!selectedSmtpCredential}>
                                            <i className="ri-eye-line me-1"></i>Ver
                                        </Button>
                                        <Button color="warning" className="me-2" onClick={() => { if (selectedSmtpCredential) setModalModificarOpen(true) }} disabled={!selectedSmtpCredential || updateLoading}>
                                            <i className="ri-edit-line me-1"></i>Modificar
                                        </Button>
                                        <Button color="danger" className="me-2" onClick={async () => {
                                            if (selectedSmtpCredential && window.confirm('¿Está seguro que desea eliminar esta credencial SMTP? Esta acción no se puede deshacer.')) {
                                                const result = await deleteSmtpCredential(selectedSmtpCredential.id);
                                                if (result) {
                                                    alert('Credencial SMTP eliminada');
                                                    setRefresh(prev => prev + 1);
                                                } else {
                                                    alert('Error: No se pudo eliminar');
                                                }
                                            }
                                        }} disabled={!selectedSmtpCredential || deleteLoading}>
                                            <i className="ri-delete-bin-line me-1"></i>Eliminar
                                        </Button>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    {error ? <div className="alert alert-danger">{error}</div> : loading ? <div className="text-center"><Spinner animation="border" variant="primary" /></div> : <TableContainer
                                        columns={(columns || [])}
                                        data={smtpCredentials?.records || []}
                                        customPageSize={15}
                                        isGlobalFilter={true}
                                        SearchPlaceholder='Buscar...'
                                        onCellClick={handleCellClick}
                                    />}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            <ModalCrearSmtpCredential
                isOpen={modalCrearOpen}
                toggle={() => setModalCrearOpen(false)}
                onSave={async (formData) => {
                    const result = await createSmtpCredential(formData);
                    if (result) {
                        alert('Credencial SMTP creada exitosamente');
                        setModalCrearOpen(false);
                        setRefresh(prev => prev + 1);
                    } else {
                        alert('Error al crear credencial SMTP: ' + createError);
                    }
                }}
            />
            <ModalModificarSmtpCredential
                isOpen={modalModificarOpen}
                toggle={() => setModalModificarOpen(false)}
                selectedSmtpCredential={selectedSmtpCredential}
                onSave={async (formData) => {
                    const result = await updateSmtpCredential(selectedSmtpCredential.id, formData);
                    if (result) {
                        alert('Credencial SMTP actualizada exitosamente');
                        setModalModificarOpen(false);
                        setRefresh(prev => prev + 1);
                    } else {
                        alert('Error al actualizar credencial SMTP: ' + updateError);
                    }
                }}
            />
            <ModalLeerSmtpCredential
                isOpen={modalLeerOpen}
                toggle={() => setModalLeerOpen(false)}
                selectedSmtpCredential={selectedSmtpCredential}
            />
        </React.Fragment>
    )
}

export default SmtpCredentials;